"use strict";

App.Pages.Comparison = class Comparison extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				user: true
			},
			path: '/comparison',
			nameRu: 'Сравнение',
		};
	}

	static get template()
	{
		//language=HTML
		return `
			<div class="page navbar-fixed">
				<div class="page-content ptr-content" pf="pageContent">

					<div class="page-header">
						<h3 pf="stellaName">Сравнение</h3>
					</div>


					<form class="filterForm" pf="form">
						<div pf="elements"></div>
						<div class="row resizable">
							<div class="col-65">
								<div pf="preset"></div>
							</div>
							<div class="col-15">
								<input pf="dates"/>
							</div>
							<div class="col-20">
								<div pf="discrete"></div>
							</div>
						</div>
						<div class="row resizable">
						<div class="col-25">
								<div pf="gender"></div>
							</div>
							<div class="col-25">
								<div pf="age"></div>
							</div>
							<div class="col-25">
								<div pf="emotion"></div>
							</div>
							<div class="col-25">
								<div pf="view"></div>
							</div>
						</div>
					</form>


					<div class="row resizable" pf="plots">
						<div class="col-70">
							<div class="card" pf="chartBlock1"></div>
							<div class="card" pf="chartBlock2"></div>
							<div class="card" pf="chartBlock3"></div>
						</div>
						<div class="col-30">
							<div class="card" pf="chartBlockEmotion"></div>
							<div class="card" pf="avgViewTime"></div>
							<!-- <div class="card" style="margin-top: 16px;">
								<h4>Среднее длительность просмотра экрана</h4>
								<div pf="chartTimes" style="display: flex; flex-wrap: nowrap;"></div>
							</div> -->
						</div>
					</div>

					<div class="preloader-wrapper" pf="preloader" style="width: fit-content; margin: auto;">
						<div class="preloader" style="margin:40px auto; ">
							<span class="preloader-inner">
								<span class="preloader-inner-gap"></span>
								<span class="preloader-inner-left">
									<span class="preloader-inner-half-circle"></span>
								</span>
								<span class="preloader-inner-right">
									<span class="preloader-inner-half-circle"></span>
								</span>
							</span>
						</div>
					</div>

				</div>
			</div>

		`;
	}

	init()
	{
		super.init();
		this.loadStatus = true;
		this.errorStatus = false;

		this.bindDom({ preloader: 'show' }, 'loadStatus');
		this.bindDom({ plots: 'show' }, ['loadStatus', 'errorStatus'], (l, e) => !l && !e);

		this.statFilters = new PF.Model({ represent: "user-data/stat-comparison", saveOnModify: true, raw: { data: {} } });

		this.statFilters.onValue('options.loadStatus', 'loaded', () =>
		{
			this.form = new PF.Form({
				dom: { element: this.dom.form },
				model: this.statFilters,
				keyPrefix: 'data.',
				toastOnSave: false,
				fieldsConfig: {
					elements: {
						class: PF.Field.MultiSelect,
						label: 'Выберете стелы, по которым построить сравнительную статистику:',
						includeRoot: false,

						key: 'stellas',
						checkConfig: {
							// allowNull: true,
							deletePolicy: 'delete',
							listConfig: {

								addable: false,
								modelsConfig: {
									represent: 'stella/view-all',
								},
							},
						},
						simpleTitle: (count) =>
						{
							Util.sleep(2).then(() =>
							{
								if (count < 4 && count > 0)
								{
									let stellas = this.statFilters.data.stellas;
									let t = Util.spell(count, ['', 'Выбрана:', 'Выбраны:', 'Выбраны:']);
									for (let i = 0; i < stellas.size; i++)
									{
										if (i === 0)
										{
											t += ` "${stellas[i].name}"`;
										} else
										{
											t += `, "${stellas[i].name}"`;
										}
									}
									this.statFilters.options.form.fields.elements.simpleTitleText = t;
								}
							});
							return `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`;
						},
					},
					dateDiapason: {
						class: PF.Field.DateDiapasonWithPreset,
						presetConfig: {
							dom: {
								element: this.dom.preset
							},
							key: 'data.diapasonPreset',
						},
						datesConfig: {
							dom: {
								element: this.dom.dates
							},
							startKey: 'data.calendar.start',
							finishKey: 'data.calendar.finish',
						},
					},
					discrete: {
						class: PF.Field.Select,
						label: 'Детализация по:',
						// class: PF.Field.ButtonsToggle,
						radioConfig: {
							listConfig: {
								modelsConfig: {
									raw: [
										{
											id: 'hour',
											name: "Часам"
										},
										{
											id: 'day',
											name: "Суткам"
										},
										{
											id: 'week',
											name: "Неделям"
										},
										{
											id: 'month',
											name: "Месяцам"
										},
									]
								}
							},
						},
					},
					gender: {
						class: PF.Field.Select,
						label: 'Выберите пол',
						radioConfig: {
							listConfig: {
								modelsConfig: {
									raw: [
										{
											id: 'all',
											name: "Все"
										},
										{
											id: 'male',
											name: "Мужчина"
										},
										{
											id: 'female',
											name: "Женщина"
										}
									]
								}
							},
						},
					},
					age: {
						class: PF.Field.Select,
						label: 'Выберите возраст',
						radioConfig: {
							listConfig: {
								modelsConfig: {
									raw: [
										{
											id: 'all',
											name: "Все"
										},
										{
											id: "18-24",
											name: "18-24"
										},
										{
											id: "25-32",
											name: "25-32"
										},
										{
											id: "33-40",
											name: "33-40"
										},
										{
											id: "41-50",
											name: "41-50"
										},
										{
											id: "51-99",
											name: "после 50"
										}
									]
								}
							},
						},
					},
					view: {
						class: PF.Field.Select,
						label: 'Выберите наличие просмотра',
						radioConfig: {
							listConfig: {
								modelsConfig: {
									raw: [
										{
											id: 'all',
											name: "Не важно"
										},
										{
											id: 'true',
											name: "Есть просмотр"
										},
										{
											id: 'false',
											name: "Нет просмотра"
										}
									]
								}
							},
						},
					},
					emotion: {
						class: PF.Field.MultiSelect,
						label: 'Выберите эмоцию',
						includeRoot: false,
						checkConfig: {
							deletePolicy: 'delete',
							listConfig: {
								modelsConfig: {
									represent: 'emotion/manage',
								},
							},
						},
						simpleTitle: (count) =>
						{
							Util.sleep(2).then(() =>
							{
								let emotion = this.statFilters.data.emotion;
								if (count == 1 && emotion.size == 1)
								{
									this.statFilters.options.form.fields.emotion.simpleTitleText = emotion[0].name;
								}
							});
							return `Выбрано ${Util.spell(count, ['', '@{v} значение', '@{v} значения', '@{v} значений'])}`;
						},
					},
				}
			}); // form

			this.statFilters.on('save-success', () =>
			{
				if (this.statFilters.get('data.stellas', null, null) !== null)
				{
					this.loadPlots();
				}
				else
				{
					this.dom.chartBlock1.empty();
					this.dom.chartBlock2.empty();
					this.dom.chartBlock3.empty();
					this.dom.chartBlockEmotion.empty();
					this.dom.chartTimes.empty();
					this.dom.avgViewTime.empty();
					app.toast("Выберете хотя бы одну сцену");
					this.errorStatus = true;
					this.loadStatus = false;
				}
			}, true);

		}); // options.loadStatus

		this.statFilters.onChange('data.diapasonPreset', () =>
		{
			if (typeof this.statFilters.get('data.diapasonPreset' + '.discrete') === 'function')
			{
				let discrete = this.statFilters.get('data.diapasonPreset' + '.discrete')();
				if (this.statFilters.get('data.discrete.id') != discrete.id)
				{
					this.statFilters.setData('data.discrete', discrete, true);
					this.statFilters.trigger('changed');
					// console.log(this.statFilters.data.discrete);
				}
			}
		}, true);

		// this.dom.chartTimes.bindHtml();

	} // init

	loadPlots()
	{
		this.loadStatus = true;
		try
		{
			this.dom.chartBlock1.empty();
			this.dom.chartBlock2.empty();
			this.dom.chartBlock3.empty();
			this.dom.chartBlockEmotion.empty();
			// this.dom.chartTimes.empty();
			this.dom.avgViewTime.empty();
			app.request('/demo/plot/stat-comparison', [], (response) =>
			{
				this.loadStatus = false;
				app.toast("Ответ получен.");
				this.response = Util.isJsonString(response) ? JSON.parse(response) : response;
				if (this.response.status != 'FAIL')
				{
					console.log(this.response.data);
					this.titleChart = '';
					if (this.statFilters.data.calendar.start === this.statFilters.data.calendar.finish)
					{
						this.titleChart = `за ${Util.toLocalDate(this.statFilters.data.calendar.start)} `;
					} else
					{
						this.titleChart = `за период с ${Util.toLocalDate(this.statFilters.data.calendar.start)} по ${Util.toLocalDate(this.statFilters.data.calendar.finish)}`;
					}
					this.errorStatus = false;
					try
					{
						this.creatCharts1();
					} catch (error)
					{
						console.log(error);
					}
					try
					{
						this.creatCharts2();
					} catch (error)
					{
						console.log(error);
					}
					try
					{
						this.creatCharts3();
					} catch (error)
					{
						console.log(error);
					}
					try
					{
						this.creatEmotion();
					} catch (error)
					{
						console.log(error);
					}
					try
					{
						this.creatAvgTimeV2();
					} catch (error)
					{
						console.log(error);
					}
				}
				else
				{
					console.log(this.response);
					app.toast("Нет данных");
					this.errorStatus = true;
				}
			});
		}
		catch (e)
		{
			console.log("loadPlots error");
			this.errorStatus = true;
		}
	} // loadPlots

	//--------------
	// построение графиков
	creatCharts1()
	{
		this.chartBlock = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlock1 },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4 class="plot">Общий поток людей ${this.titleChart}</h4>`,
				align: 'left',
			},
			chart: {
				height: 515,
				type: 'spline'
			},
			xAxis: {
				categories: this.response.data.countDetection.x,
				labels: { format: '{value}' }
			},
			yAxis: {
				title: { text: 'Кол-во детекций' }
			},
			series: this.response.data.countDetection.chartsDetects,
			plotOptions: {
				column: {
					stacking: 'normal',
					dataLabels: {
						enabled: true
					}
				},
				area: {
					pointStart: 1940,
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				},
				// series: {
				// 	point: {
				// 		events: {
				// 			click: function (e) {
				// 				console.log(this, e);
				// 			 }
				// 		}
				// 	}
				// }
			},
		});
	} // creatCharts1

	creatCharts2()
	{
		let series = this.response.data.avgViewTimeСolumn.data;
		this.chartBlock = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlock2 },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4 class="plot">Средняя длительность просмотра ${this.titleChart}</h4>`,
				align: 'left',
			},
			chart: {
				type: 'column'
			},
			xAxis: {
				categories: this.response.data.avgViewTimeСolumn.x,
				labels: { format: '{value}' }
			},
			yAxis: {
				type: 'datetime',
				title: { text: 'длительность просмотра (мин:сек)' },
				// min: Date.UTC(2021, 4, 1, 0),
				// max: Date.UTC(2021, 4, 1, 1),
				// tickInterval: 2,
				min: 0,
				max: this.response.data.avgViewTimeСolumn.y,
				tickInterval: this.response.data.avgViewTimeСolumn.tickInterval,
				labels: {
					formatter()
					{
						let s = this.value;
						let hrs = Math.floor(s / 60 / 60);
						let mins = Math.floor(s / 60) - (hrs * 60);
						let secs = s % 60;
						// let ms = s % 1000;

						let output = hrs > 0 ? hrs + ":" : "";
						output += mins > 0 ? mins + ":" : "0:";
						output += secs > 0 ? secs : "0";
						// output += ms > 0 ? ms : "0";
						return output
					}
				}
				// labels: {
				// 	formatter() {
				// 		let output = Duration.fromISOTime(this.value).toFormat("m:s");
				// 		return output
				// 	}
				// }
			},
			tooltip: {
				headerFormat: '<b>"{series.name}"</b> за {point.x}<br>',
				// headerFormat: '',
				// pointFormat: '{point.name}: <b>{point.z}</b>',

				pointFormatter: function ()
				{
					let stele = this.series.userOptions.name;
					let time = Duration.fromISOTime(this.series.userOptions.data[this.x][2]).toFormat("m:s.S");
					// console.log(this);
					return `В среднем смотрели:<br> ${time}`;
				}
			},
			series: series,
			plotOptions: {
				column: {
					pointPadding: 0.2,
					borderWidth: 0
				},
				area: {
					pointStart: 1940,
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},
		});
	} // creatCharts2

	creatCharts3()
	{
		this.chartBlock = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlock3 },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4 class="plot">Соотношение детекций с просмотром и прошедших мимо<br>${this.titleChart}</h4>`,
				align: 'left',
			},
			chart: {
				type: 'column'
			},
			tooltip: {
				formatter: function ()
				{
					var stackName = this.series.userOptions.stack;
					let raw = this.series.userOptions.data[this.point.x][2];
					let all = this.series.userOptions.data[this.point.x][3];
					return stackName + '<br/> в <b>' + this.x + '</b>.<br/>' +
						'Из ' + all + ' смотрели: ' + raw + ' (' + (Math.trunc(this.y * 100) / 100) + '%)';
					// this.series.name + ': ' + this.y + '<br/>' +
					// 'Всего: ' + this.point.stackTotal;
				}
			},
			legend: {
				// labelFormatter: function ()
				// {
				// 	return this.name + ' (' + this.userOptions.stack + ')';
				// }
			},
			xAxis: {
				categories: this.response.data.countDetection.x,
				labels: { format: '{value}' },
				crosshair: true
			},
			yAxis: {
				title: { text: '%' },
				min: 0,
				max: 100,
				tickInterval: 10
			},
			series: this.response.data.countDetection.chartsHasView,
			plotOptions: {
				column: {
					// pointPadding: 0.2,
					// borderWidth: 0
					stacking: 'normal',
					dataLabels: {
						enabled: false
					}
				},
				area: {
					pointStart: 1940,
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},
		});
	} // creatCharts3

	creatEmotion()
	{
		this.chartBlock = new PF.Charts.Highcharts({
			dom: { element: this.dom.chartBlockEmotion },
			title: {
				useHTML: true,
				//language=HTML
				text: `<h4 class="plot">Соотношение эмоций за период</h4>`,
				align: 'left',
			},
			chart: {
				height: 515,
				type: 'column'
			},
			xAxis: {
				categories: this.response.data.avgEmotion.x,
				labels: { format: '{value}' }
			},
			yAxis: {
				title: { text: 'Кол-во детекций' }
			},
			series: this.response.data.avgEmotion.series,
			plotOptions: {
				column: {
					pointPadding: 0.2,
					borderWidth: 0
				},
				area: {
					pointStart: 1940,
					marker: {
						enabled: false,
						symbol: 'circle',
						radius: 2,
						states: {
							hover: {
								enabled: true
							}
						}
					}
				}
			},
		});
	} // creatEmotion

	/**
	 * Среднее длительность просмотра экрана v1
	 */
	creatAvgTime()
	{
		if (this.response.data.avgViewTimePie.sum != 0)
		{
			// с часами, для каждой стеле
			let option = {
				exporting: { enabled: false },
				legend: { enabled: false },
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.dt}</b>'
				},
				accessibility: {
					point: {
						valueSuffix: '%'
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: false,
							// format: '{point.percentage:.1f} %'
						},
						showInLegend: true
					}
				}
			}; // option
			let avg = this.response.data.avgViewTimePie.avg;

			for (let index = 0; index < avg.length; index++)
			{
				let w = 100 / avg.length;
				let name = 'chartTimes' + index;
				this.dom.load(`
				<div style="width: ${w}%; background-color: #fff;">
					<div style="width: 100%; height: 140px;" pf="${name}"> </div>
					<div style="text-align: center; color: #666;">${avg[index].stella}</div>
				</div>`, 'parent' + name);
				this.dom.chartTimes.append(this.dom['parent' + name]);

				this.time = new PF.Charts.Highcharts({
					dom: { element: this.dom[name]},
					title: {
						useHTML: true,
						text: `
                    <div style="display: block; min-width: 60px;">
                        <div style="color: #EB4F4A; display: block; text-align: center;">${Duration.fromISOTime(avg[index].avg).toFormat("mm:ss")}</div>
                        <div style="font-size: 8px; display: flex; justify-content: space-between">
                            <div>минут</div>
                            <div>секунд</div>
                        </div>
                    </div>`,
						// style: {
						//     fontSize: '15px'
						// },
						align: 'center',
						verticalAlign: 'middle',
						// y: 0
					},
					series: [
						{
							name: 'Время',
							innerSize: '80%',
							colorByPoint: true,
							data: [
								{
									name: 'avg',
									color: '#3672E1',
									y: Duration.fromISOTime(avg[index].avg).toMillis(),
									dt: avg[index].avg
								}, {
									name: 'Other',
									color: '#E3ECF9',
									y: Duration.fromISOTime(avg[index].tr).toMillis(),
									dt: avg[index].tr
								}
							]
						}
					],
					...option
				});


			} // for avg.length
		} // if
	} // creatAvgTime

	/**
	 * Средняя длительность просмотра экрана v2
	 */
	creatAvgTimeV2()
	{
		if (this.response.data.avgViewTimePie.sum != 0)
		{
			// вариант 2, единая диаграмма
			let series = this.response.data.avgViewTimePie.series;

			for (let index = 0; index < series.data.length; index++)
			{
				series.data[index].y = Duration.fromISOTime(series.data[index].y).toMillis()
			}
			this.avgViewTime = new PF.Charts.Highcharts({
				dom: { element: this.dom.avgViewTime },
				title: {
					useHTML: true,
					//language=HTML
					text: `<h4>Средняя длительность просмотра экрана</h4>`,
					align: 'left',
				},
				legend: {
					labelFormatter: function ()
					{
						return this.name + ' (' + Duration.fromISOTime(this.dt).toFormat("mm:ss.S") + ')';
					}
				},
				series: [series],
				exporting: { enabled: false },
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.dt}({point.percentage:.1f}%)</b>'
				},
				accessibility: {
					point: {
						valueSuffix: '%'
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: false,
							// format: '{point.percentage:.1f} %'
						},
						showInLegend: true
					}
				}
			}); // avgViewTime
		} // if
	} // creatAvgTimeV2

};

